import script from "./Bullet.vue?vue&type=script&lang=js"
export * from "./Bullet.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__